export const PORTRAIT_PRIMARY = 0;
export const PORTRAIT_SECONDARY = 180;
